import { Component, FunctionComponent, ReactNode } from "react";
import RenderError from "./RenderError";

class ErrorBoundry extends Component {
  state = {
    error: false,
    errInfo: undefined,
  };
  componentDidCatch(err: any, errInfo: { componentStack: string }) {
    console.dir("The Error has occured! Check the error info below");
    console.log(err);
    this.setState({ error: true, errInfo: err });
  }
  render(): ReactNode {
    if (this.state.error)
      return <RenderError componentStack={this.state.errInfo} />;

    return this.props.children;
  }
}

export default function WithErrorBoundry<T extends Record<string, any>>(
  Component: FunctionComponent<T>
) {
  return function withLayoutComponent(props: T): JSX.Element {
    return (
      <ErrorBoundry>
        <Component {...props} />
      </ErrorBoundry>
    );
  };
}
